"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateRangeOptionsValues = exports.dateRangeOptions = exports.USER_ROLE_ENUMS = exports.TOAST_NOTIFICATIONS_TYPES = exports.TEAM_MEMBER_ROLE = exports.SWIPE_TRACKER_EVENTS = exports.STATUS_OPTIONS = exports.SORT_BY_OPTIONS = exports.SHAPE_ENUMS = exports.INSTRUCTION_TYPE = exports.GUIDE_FILTER_OPTIONS = exports.FEEDBACK_PARENT_TYPE_ENUM = exports.DOMAIN_LOGIN_OPTIONS = exports.DOMAIN_LOGIN_FORBIDDEN_ACTIONS = exports.CUSTOM_SIGNOFF_FILTER_OPTIONS = exports.CUSTOM_FILTER_OPTIONS = exports.COOKIE_PREFERENCE_OPTIONS = exports.CAMPAIGN_TRIGGER_KIND_ENUMS = exports.CAMPAIGN_STATUS_ENUMS = exports.CAMPAIGN_QUESTION_TYPE_ENUMS = exports.CAMPAIGN_FOLLOW_UP_TYPE_ENUMS = void 0;
var CAMPAIGN_QUESTION_TYPE_ENUMS = exports.CAMPAIGN_QUESTION_TYPE_ENUMS = {
  STAR: 'STAR',
  YES_NO: 'YES_NO',
  PASS_FAIL: 'PASS_FAIL',
  NUMBER: 'NUMBER',
  TEXT: 'TEXT'
};
var CAMPAIGN_FOLLOW_UP_TYPE_ENUMS = exports.CAMPAIGN_FOLLOW_UP_TYPE_ENUMS = {
  TEXT: 'TEXT',
  TIME: 'TIME'
};
var CAMPAIGN_STATUS_ENUMS = exports.CAMPAIGN_STATUS_ENUMS = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED'
};
var CAMPAIGN_TRIGGER_KIND_ENUMS = exports.CAMPAIGN_TRIGGER_KIND_ENUMS = {
  ALWAYS: 'ALWAYS',
  VIEWED_INSTRUCTIONS: 'VIEWED_INSTRUCTIONS',
  TIME: 'TIME'
};
var TEAM_MEMBER_ROLE = exports.TEAM_MEMBER_ROLE = {
  EDITOR: 'EDITOR',
  ADMIN: 'ADMIN',
  VIEWER: 'VIEWER'
};

// TODO: This will be deprecated. After changes on native client for users revamp this should be removed
var USER_ROLE_ENUMS = exports.USER_ROLE_ENUMS = {
  EDITOR: 'EDITOR',
  ADMIN: 'ADMIN',
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  VIEWER: 'VIEWER'
};
var SWIPE_TRACKER_EVENTS = exports.SWIPE_TRACKER_EVENTS = {
  PAGEVIEW: 'pageview',
  ACTION: 'action',
  SEARCH: 'search'
};
var FEEDBACK_PARENT_TYPE_ENUM = exports.FEEDBACK_PARENT_TYPE_ENUM = {
  GUIDE: 'GUIDE',
  INSTRUCTION: 'INSTRUCTION',
  STEP: 'STEP'
};
var SHAPE_ENUMS = exports.SHAPE_ENUMS = {
  ARROW: 'arrow',
  RECT: 'rectangle',
  LINE: 'line',
  ELLIPSE: 'ellipse'
};
var SORT_BY_OPTIONS = exports.SORT_BY_OPTIONS = {
  DRAFT_TITLE: 'DRAFT_TITLE',
  PUBLISHED_TITLE: 'PUBLISHED_TITLE',
  LAST_PUBLISHED: 'LAST_PUBLISHED',
  CREATION_DATE: 'CREATION_DATE',
  LAST_UPDATED: 'LAST_UPDATED',
  ASSIGNED_TO: 'ASSIGNED_TO'
};
var GUIDE_FILTER_OPTIONS = exports.GUIDE_FILTER_OPTIONS = {
  ALL_GUIDES: 'ALL_GUIDES',
  MY_GUIDES: 'MY_GUIDES',
  TEAM_GUIDES: 'TEAM_GUIDES'
};

// TODO:
// This shall be renamed to something
// specific to knowledge sharing filters
// cause now we have introduced signoffs filter options
// and it gets inconsistent.

var CUSTOM_FILTER_OPTIONS = exports.CUSTOM_FILTER_OPTIONS = {
  TAG: 'TAG',
  TEAM: 'TEAM',
  ASSIGNEE: 'ASSIGNEE',
  WORKSPACE: 'WORKSPACE',
  LANGUAGE: 'LANGUAGE'
};
var CUSTOM_SIGNOFF_FILTER_OPTIONS = exports.CUSTOM_SIGNOFF_FILTER_OPTIONS = {
  SIGNOFF: 'SIGNOFF',
  START_DATE: 'START_DATE',
  END_DATE: 'END_DATE',
  GUIDE: 'GUIDE',
  WORKSPACE: 'WORKSPACE',
  TAG: 'TAG'
};
var STATUS_OPTIONS = exports.STATUS_OPTIONS = {
  ALL: 'ALL',
  PUBLISHED: 'PUBLISHED',
  DRAFT: 'DRAFT'
};
var INSTRUCTION_TYPE = exports.INSTRUCTION_TYPE = {
  INSTRUCTION: 'INSTRUCTION',
  CHECKLIST: 'CHECKLIST'
};
var TOAST_NOTIFICATIONS_TYPES = exports.TOAST_NOTIFICATIONS_TYPES = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};
var today = {
  id: 'today'
};
var yesterday = {
  id: 'yesterday'
};
var last7days = {
  id: 'last7days'
};
var last30days = {
  id: 'last30days'
};
var lastMonth = {
  id: 'lastMonth'
};
var weekToDate = {
  id: 'weekToDate'
};
var monthToDate = {
  id: 'monthToDate'
};
var custom = {
  id: 'custom'
};
var dateRangeOptions = exports.dateRangeOptions = [today, yesterday, last7days, last30days, lastMonth, weekToDate, monthToDate, custom];
var dateRangeOptionsValues = exports.dateRangeOptionsValues = {
  today: today,
  yesterday: yesterday,
  last7days: last7days,
  last30days: last30days,
  lastMonth: lastMonth,
  weekToDate: weekToDate,
  monthToDate: monthToDate,
  custom: custom
};
var COOKIE_PREFERENCE_OPTIONS = exports.COOKIE_PREFERENCE_OPTIONS = {
  YES: 'yes',
  NO: 'no'
};
var DOMAIN_LOGIN_OPTIONS = exports.DOMAIN_LOGIN_OPTIONS = {
  SSO: 'SSO',
  EMAIL: 'EMAIL',
  PHONE_NUMBER: 'PHONE_NUMBER',
  DOMAIN_PASSWORD: 'DOMAIN_PASSWORD'
};
var DOMAIN_LOGIN_FORBIDDEN_ACTIONS = exports.DOMAIN_LOGIN_FORBIDDEN_ACTIONS = {
  SHOW_SSO_DIALOG: 'SHOW_SSO_DIALOG',
  REDIRECT_AND_LOGOUT: 'REDIRECT_AND_LOGOUT'
};
//# sourceMappingURL=enums.js.map